import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';
import uniqBy from 'lodash/uniqBy';

import * as constants from './constants';
import { StoreState, ThemesAction, ThemesStoreState } from './typings';

const initialState: StoreState = {
    themes: {},
};

const initialStateForSubject = (): ThemesStoreState => ({
    rootThemesLoadingStatus: LOADING_STATUSES.UNSENT,
    themes: [],
    actualThemes: {},
    themesTreeLoadingStatus: {},
    actualThemesLoadingStatus: {},
});

const themesReducer = (state: StoreState = initialState, action: ThemesAction) => {
    // eslint-disable-next-line complexity
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.GET_ROOT_THEMES_REQUEST: {
                const { subject } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].rootThemesLoadingStatus = LOADING_STATUSES.LOADING;

                break;
            }

            case constants.GET_ROOT_THEMES_SUCCESS: {
                const { themes, subject } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].rootThemesLoadingStatus = LOADING_STATUSES.SUCCESS;
                //@ts-ignore
                draft.themes[subject].themes = uniqBy(themes.concat(state.themes[subject]?.themes || []), 'id');

                break;
            }

            case constants.GET_ROOT_THEMES_ERROR: {
                const { subject } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].rootThemesLoadingStatus = LOADING_STATUSES.ERROR;

                break;
            }

            case constants.GET_THEMES_TREE_REQUEST: {
                const { themeId, subject } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].themesTreeLoadingStatus[themeId] = LOADING_STATUSES.LOADING;

                break;
            }

            case constants.GET_THEMES_TREE_SUCCESS: {
                const { themeId, themes, subject, rootId } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                const initialThemes = state.themes[subject]?.themes || initialStateForSubject().themes;

                draft.themes[subject].themesTreeLoadingStatus[themeId] = LOADING_STATUSES.SUCCESS;
                draft.themes[subject].themesTreeLoadingStatus[rootId] = LOADING_STATUSES.SUCCESS;
                draft.themes[subject].themes = uniqBy(initialThemes.concat(themes), 'id');

                break;
            }

            case constants.GET_THEMES_TREE_ERROR: {
                const { themeId, subject } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].themesTreeLoadingStatus[themeId] = LOADING_STATUSES.ERROR;

                break;
            }

            case constants.SET_THEMES_TREE_LOADING_STATUS: {
                const { themeId, subject, status } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].themesTreeLoadingStatus[themeId] = status;

                break;
            }

            case constants.GET_ACTUAL_THEMES_REQUEST: {
                const { subject, courseId } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].actualThemesLoadingStatus[courseId] = LOADING_STATUSES.LOADING;

                break;
            }
            case constants.GET_ACTUAL_THEMES_SUCCESS: {
                const { themes, subject, courseId } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].actualThemesLoadingStatus[courseId] = LOADING_STATUSES.SUCCESS;
                draft.themes[subject].actualThemes[courseId] = themes;

                break;
            }
            case constants.GET_ACTUAL_THEMES_ERROR: {
                const { subject, courseId } = action;

                if (!draft.themes[subject]) {
                    draft.themes[subject] = initialStateForSubject();
                }

                draft.themes[subject].actualThemesLoadingStatus[courseId] = LOADING_STATUSES.ERROR;

                break;
            }

            default:
                break;
        }
    });
};

export default themesReducer;
